import { FileName } from 'components/file/FileName';
import { FileSize } from 'components/file/FileSize';
import { Image } from 'components/Image';
import { classNames } from 'libs/react';
import { React } from 'libs/react';
import { useMedia } from 'components/media/MediaProvider';
import { Button } from 'components/Button';
import { MediaKind } from 'libs/media/MediaType';
import { MediaType } from 'libs/media/MediaType';
import './MediaUploadItem.scss';
/**
 * @component MediaUploadItem
 * @since 1.0.0
 */
export function MediaUploadItem(props) {
    const { style, upload } = Object.assign({ style: 'normal' }, props);
    const { retryUpload, dismissUpload } = useMedia();
    let image = '';
    switch (MediaType.getKind(upload.mimetype)) {
        case MediaKind.Image:
            image = upload.data;
            break;
        case MediaKind.Video:
            image = '/images/video.svg';
            break;
        case MediaKind.Audio:
            image = '/images/audio.svg';
            break;
    }
    const progress = {
        width: upload.progress * 100 + '%'
    };
    /**
     * @function onRetry
     * @since 1.0.0
     * @hidden
     */
    function onRetry() {
        retryUpload(upload.id);
    }
    /**
     * @function onDismiss
     * @since 1.0.0
     * @hidden
     */
    function onDismiss() {
        dismissUpload(upload.id);
    }
    const className = classNames('media-upload-item', 'media-upload-item--' + style, { 'media-upload-item--has-error': upload.error }, props.className);
    return (React.createElement("div", { className: className },
        React.createElement("div", { className: "media-upload-item-head" },
            React.createElement(Image, { className: "media-upload-item-image", source: image })),
        React.createElement("div", { className: "media-upload-item-body" },
            React.createElement("div", { className: "media-upload-item-infos" },
                React.createElement(FileName, { className: "media-upload-item-file-name", value: upload.filename }),
                React.createElement(FileSize, { className: "media-upload-item-file-size", value: upload.filesize })),
            upload.error ? (React.createElement("div", { className: "media-upload-item-error" }, upload.error)) : (React.createElement("div", { className: "media-upload-item-progress" },
                React.createElement("div", { className: "media-upload-item-progress-value", style: progress })))),
        upload.error && (React.createElement("div", { className: "media-upload-item-foot" },
            upload.file && (React.createElement(Button, { className: "media-upload-item-retry", style: "picto", picto: "rotate", onPress: onRetry })),
            React.createElement(Button, { className: "media-upload-item-dismiss", style: "picto", picto: "xmark", onPress: onDismiss })))));
}
